webpackJsonp([82954407234362],{

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	__webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['services', 'vendor', 'brokering', 'consulting'];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'services' },
	    _react2.default.createElement(
	      'div',
	      { className: 'services-hero' },
	      _react2.default.createElement('div', { className: 'services-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'services-title' },
	      'Services'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'services-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'services', current: 'services' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'services-intro' },
	        'We take pride in offering our clients great customer service. We tailor every equipment leasing and financing solution specifically for each individual customer. Whether you are a ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'lessee'
	        ),
	        ' looking for the best way to fund an equipment acquisition, a ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'vendor'
	        ),
	        ' looking to add value to your equipment offering, or a ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'leasing company'
	        ),
	        ', ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'lease or finance broker'
	        ),
	        ' looking to solve a seemingly impossible problem, we want to help. Put our vast experience in the equipment leasing industry to work for you.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-index-js-c9c108e190c5c06726de.js